(function ($) {
  'use strict';

  /**
   * Remove honeypot input requirement
   */

  var spambotCode, spambotMessage, recaptcha;

  if (window && window.ys && window.ys.skodaNewsletters) {
    spambotCode = window.ys.skodaNewsletters.spambotCode;
    spambotMessage = window.ys.skodaNewsletters.spambotMessage;
    recaptcha = window.ys.recaptcha_key;

    // Check if reCaptcha is disabled
    if (
      typeof window.newsletter_disabled !== 'undefined' &&
      typeof window.newsletter_disabled.newsletter_recaptcha_disabled !==
        'undefined'
    ) {
      recaptcha = false;
    }
  }

  var Newsletters = function ($wrapper) {
    if (!$wrapper.length) {
      return;
    }

    this.$wrapper = $wrapper;

    this.$wrapper.find('input.title-name').removeAttr('required').val('');

    this.$form = $wrapper.find('form');
    this.$response = this.$form.find('.ajax-response');
    this.$button = this.$form.find('button[type="submit"]');

    this.data = null;

    this.captcha = true;

    if (!recaptcha) {
      this.$form.on('submit', this.submit.bind(this));
      this.captcha = false;
    }

    this.$wrapper.one('click touchstart', this.loadWidget.bind(this));

    this.$wrapper.find('header').on('click', function () {
      $(this).parent().find('input:first').focus();
    });

    this.$wrapper.on(
      'click',
      '.removeSpambotProtection',
      function () {
        this.$wrapper.find('input.title-name').remove();
        this.$wrapper.find('form').submit();
      }.bind(this)
    );

    var params = window.location.search.slice(1);

    if (params && typeof window.dataLayer !== 'undefined') {
      params = params.split('&');
      if (params.indexOf('newsletterSubscriptionConfirmed=true') > -1) {
        window.dataLayer.push({
          event: 'gaEvent',
          eventCategory: 'user',
          eventAction: 'confirmation',
          eventLabel: 'newsletter',
        });
      }
    }
  };

  Newsletters.prototype.loadWidget = function (e) {
    if (this.captcha) {
      this.$button.addClass('loading').attr('disabled', 'disabled');
      if (window.recaptchaLoaded) {
        this.loadReCaptcha();
      } else {
        $(document).on('recaptchaLoaded', this.loadReCaptcha.bind(this));
      }

      if (this.$button.is(e.target)) {
        this.$button.data('submitPending', true);
      }
    }
  };

  /**
   * Load necessary hooks
   * @returns {boolean}
   */
  Newsletters.prototype.loadReCaptcha = function () {
    this.$form.each(
      function (index, element) {
        var $captcha = $(
          '<div class="g-recaptcha" data-size="invisible"></div>'
        );
        $(element).after($captcha);
        var id = grecaptcha.render($captcha.get(0), {
          sitekey: recaptcha,
          callback: this.post.bind(this),
        });
        $(element).data('widgetId', id);
      }.bind(this)
    );

    this.$button.removeClass('loading').removeAttr('disabled');

    this.$form.on('submit', this.submit.bind(this));
    if (this.$button.data('submitPending')) {
      this.$button.data('submitPending', null);
      this.$form.submit();
    }
  };

  Newsletters.prototype.submit = function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    this.$button.addClass('loading').attr('disabled', true);

    // Reset field for the ajax response
    this.$response.removeClass('alert-success alert-error').html('');

    // Prepare data to be sent
    var data = new FormData(e.currentTarget);
    data.append('action', 'skoda_newsletter_signup');

    this.data = data;

    if (this.captcha) {
      window.grecaptcha.execute($(e.currentTarget).data('widgetId'));
    } else {
      this.post();
    }
  };

  Newsletters.prototype.post = function (token) {
    if (token) {
      this.data.append('recaptcha', token);
    }

    $.ajax({
      method: 'POST',
      url: window.ys.ajax_url,
      processData: false,
      contentType: false,
      mimeType: 'multipart/form-data',
      data: this.data,
      dataType: 'json',
      success: function (xhr) {
        // Set message if any
        if (xhr.message) {
          this.$response.html(xhr.message);

          if (xhr.status === 'success') {
            this.$response.addClass('alert-success');
          } else {
            this.$response.addClass('alert-error');

            if (xhr.errorCode === spambotCode) {
              this.$response.append(
                '<br /><button class="removeSpambotProtection">' +
                  spambotMessage +
                  '</button>'
              );
            }
          }

          if (this.$response.offset().top < window.pageYOffset) {
            $('html,body').animate(
              {
                scrollTop: this.$response.offset().top,
              },
              500,
              'swing'
            );
          }
        }

        if (xhr.status === 'success') {
          this.$form.get(0).reset();
          this.$form.find('fieldset.inputs').slideUp();
          if (typeof window.dataLayer !== 'undefined') {
            window.dataLayer.push({
              event: 'gaEvent',
              eventCategory: 'user',
              eventAction: 'signup',
              eventLabel: 'newsletter',
            });
          }
        }
      }.bind(this),
      complete: function () {
        this.data = null;
        this.$button.attr('disabled', false).removeClass('loading');
        if (this.captcha) {
          this.$form.each(
            function (index, element) {
              window.grecaptcha.reset($(element).data('widgetId'));
            }.bind(this)
          );
        }
      }.bind(this),
    });
  };

  new Newsletters($('.newsletter-subscribe'));
  new Newsletters($('.toolbar__newsletter'));
  // new Newsletters($('.scholaris-form-wrapper'));
})(jQuery);
